module.exports = __webpack_public_path__ + "img/MV.f29666eb.svg";